/* Journal colour study: sorts the server-rendered table (sections/gr-article-study.liquid).
   Each row carries data-name, data-warmth, data-vividness and data-lightness. */
(() => {
  document.querySelectorAll('[data-grj-study]').forEach((root) => {
    const tbody = root.querySelector('tbody');
    const bar = root.querySelector('.grj-sort');
    if (!tbody || !bar) return;
    const buttons = [...bar.querySelectorAll('[data-grj-sort]')];
    const sortBy = (button) => {
      const key = button.dataset.grjSort;
      const dir = Number(button.dataset.dir) || 1;
      const rows = [...tbody.rows].sort((x, y) => (key === 'name'
        ? x.dataset.name.localeCompare(y.dataset.name, undefined, { sensitivity: 'base' })
        : Number(x.dataset[key]) - Number(y.dataset[key])) * dir);
      rows.forEach((row, i) => {
        row.cells[0].textContent = i + 1;
        tbody.appendChild(row);
      });
      buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    };
    buttons.forEach((b) => b.addEventListener('click', () => sortBy(b)));
    bar.hidden = false;
    sortBy(buttons.find((b) => b.getAttribute('aria-pressed') === 'true') || buttons[0]);
  });
})();
